<div class="row row-container" *ngFor="let question of countedRespondentGroup">
  <div
    class="col-2 pr-0"
    [ngClass]="{ 'bold-text': question.participantCategoryType === categoryType.OverallExcludeSelf }"
  >
    {{ getCategoryTitle(question) | translate }}
  </div>
  <div class="progress-parent col-5" *ngIf="canShowScale(question)">
    <div class="scale-container">
      <div [ngClass]="['progress', reportingService.getScoreType(question.participantCategoryType) + '-opacity']">
        <div
          [ngClass]="['progress-bar', reportingService.getScoreType(question.participantCategoryType)]"
          [ngStyle]="{ width: (question.averageValue / scaleMaxValue) * 100 + '%' }"
        ></div>
      </div>
      <div class="scale-values-wrapper">
        <div class="scale-value" *ngFor="let answer of question.answers">{{ answer.respondentCount }}</div>
      </div>
    </div>
  </div>
  <div class="col-1" *ngIf="canShowScale(question)">
    <div class="font-weight-bold">
      {{ question.averageValue }}
    </div>
  </div>
  <div class="col-6" *ngIf="!canShowScale(question)">
    <div class="not-enough-responses-info">
      The average is available when there are 3 or more responses (in the group)
    </div>
  </div>
</div>
